import { Body, Controller, Delete, Get, Param, Patch, Post, Query, UseGuards } from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiOperation, ApiTags } from '@nestjs/swagger';
import { RequireModule } from '../../auth/decorators/require-module.decorator';
import { RequirePermission } from '../../auth/decorators/require-permission.decorator';
import type { LoginUserInfo } from '../../auth/dto/login.dto';
import { GetUser } from '../../auth/get-user.decorator';
import { ModuleGuard } from '../../auth/guards/module.guard';
import { PermissionGuard } from '../../auth/guards/permission.guard';
import { CreateEmpleadoDto } from '../dto/create-empleado.dto';
import { QueryEmpleadosDto } from '../dto/query-empleados.dto';
import { UpdateEmpleadoDto } from '../dto/update-empleado.dto';
import { EmpleadosService } from '../services/empleados.service';

@ApiTags('RRHH - Empleados')
@Controller({ path: 'rrhh/empleados', version: '1' })
@UseGuards(AuthGuard('jwt'), ModuleGuard, PermissionGuard)
@RequireModule('RRHH')
@ApiBearerAuth()
export class EmpleadosController {
  constructor(private readonly service: EmpleadosService) {}

  @Get()
  @RequirePermission('RRHH', 'RH_EMP_EMPLEADO_VER')
  @ApiOperation({ summary: 'Listar empleados con filtros y paginación' })
  listar(@GetUser() user: LoginUserInfo, @Query() query: QueryEmpleadosDto) {
    return this.service.listar(user.empresa_id, query);
  }

  @Get(':id')
  @RequirePermission('RRHH', 'RH_EMP_EMPLEADO_VER')
  @ApiOperation({ summary: 'Obtener detalle de empleado' })
  obtener(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.obtener(id, user.empresa_id);
  }

  @Post()
  @RequirePermission('RRHH', 'RH_EMP_EMPLEADO_CREAR')
  @ApiOperation({ summary: 'Dar de alta un empleado' })
  crear(@GetUser() user: LoginUserInfo, @Body() dto: CreateEmpleadoDto) {
    return this.service.crear(user.empresa_id, dto, user.id);
  }

  @Patch(':id')
  @RequirePermission('RRHH', 'RH_EMP_EMPLEADO_EDITAR')
  @ApiOperation({ summary: 'Actualizar empleado' })
  actualizar(@Param('id') id: string, @GetUser() user: LoginUserInfo, @Body() dto: UpdateEmpleadoDto) {
    return this.service.actualizar(id, user.empresa_id, dto);
  }

  @Delete(':id')
  @RequirePermission('RRHH', 'RH_EMP_EMPLEADO_ELIMINAR')
  @ApiOperation({ summary: 'Dar de baja (estado EGRESADO)' })
  eliminar(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.eliminar(id, user.empresa_id);
  }
}
